import Route from '@models/route';

export default class RouteApp extends Route {
    resource() {
        return 'route-app';
    }
}
